<template>
    <q-page class="q-pa-md">

        <q-dialog v-model="dialogAceptarCotizacion" persistent>
            <q-card v-if="cotizacionSeleccionada != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Confirmas la aceptación de la cotización, por el proveedor
                                <strong>{{ cotizacionSeleccionada.rfc + " - " + cotizacionSeleccionada.razon_social
                                }}</strong>.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Una vez aceptada la cotización, un administrador se encargará de procesar el
                            contrato.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="Cerrar" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="UpdateAceptarCotizacion()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogVistaPrevia" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vista previa Cotización</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDFPrevia" />
                    </div>
                    <VistasPreviasPDF></VistasPreviasPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 1200px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Cotizaciones</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section v-if="selectSolicitud">
                    <q-list bordered separator class="q-mt-md">
                        <q-item v-for="(file, index) in listaCotizaciones" :key="index">
                            <q-item-section avatar>
                                <q-icon name="insert_drive_file" color="primary" />
                            </q-item-section>
                            <q-item-section class="col-3 gt-sm">
                                <q-item-label class="q-mt-sm">{{ file.fecha_creacion }}</q-item-label>
                            </q-item-section>
                            <q-item-section top>
                                <q-item-label lines="1"
                                    class="q-mt-xs text-body2 text-weight-bold text-primary text-uppercase">
                                    <span>{{ file.rfc + ' - ' + file.razon_social }}</span>
                                </q-item-label>
                                <q-item-label caption lines="2">
                                    {{ file.representante + ', ' + file.correo + ', ' + file.telefono + ', ' +
                                        file.domicilio_fiscal }}
                                </q-item-label>
                                <q-separator />
                                <!-- <q-item-label lines="1">
                                    <span class="text-weight-medium">{{ file.nombre_archivo_agencia }}</span>
                                    <span class="text-grey-8"> - Cotización de la agencia</span>
                                </q-item-label>
                                <q-separator /> -->
                                <q-item-label lines="1">
                                    <span class="text-weight-medium">{{ file.nombre_archivo_arrendafit }}</span>
                                    <span class="text-grey-8"> - Cotización de ArrendaFit</span>
                                </q-item-label>
                                <q-item-label lines="1">
                                    <q-chip size="sm" color="primary" text-color="white" icon="mdi-currency-usd">
                                        Precio: {{ file.precio }}
                                    </q-chip>
                                    <q-chip size="sm" color="primary" text-color="white" icon="mdi-currency-usd">
                                        Anticipo: {{ file.anticipo }}
                                    </q-chip>
                                    <q-chip size="sm" color="primary" text-color="white" icon="mdi-currency-usd">
                                        Seguro: {{ file.seguro }}
                                    </q-chip>
                                    <q-chip size="sm" color="primary" text-color="white" icon="mdi-currency-usd">
                                        Enplacamiento: {{ file.placas }}
                                    </q-chip>
                                    <q-chip size="sm" color="primary" text-color="white" icon="mdi-calendar">
                                        Plazos: {{ file.plazo }}
                                    </q-chip>
                                    <q-chip size="sm" color="primary" text-color="white" icon="mdi-currency-usd">
                                        V.R.: {{ file.valorres }}
                                    </q-chip>
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <div class="q-gutter-xs">
                                    <q-btn icon="mdi-file-document" flat round color="primary"
                                        @click="VerArchivo(file)" />
                                    <q-radio v-model="cotizacionSeleccionada" :val="file" color="primary" />
                                </div>
                            </q-item-section>
                        </q-item>
                    </q-list>
                    <div class="row doc-note" v-if="selectSolicitud.estatus == 'Aceptada'">
                        <div class="doc-note__title full-width">Notas</div>
                        <p class="">Hay cotizaciones disponibles. Por favor, seleccione la que más le convenga y
                            confirme los datos.</p>
                    </div>
                </q-card-section>
                <q-card-actions class="row justify-between">
                    <q-btn outline flat color="red" label="Cerrar" class="q-ml-sm" />
                    <q-btn outline flat class="q-ml-sm" color="primary" label="Aceptar Cotización"
                        @click="AceptarCotizacion()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class=" col-12">
                <q-table dense title="Solicitudes" class="shadow-1" :data="solicitudes" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar"
                            @click="GetSolicitudesUsuario()" no-caps class="q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="fecha_solicitud" :props="props" @click="verItem(props.row)">{{
                                props.row.fecha_solicitud }}</q-td>
                            <q-td key="marca" :props="props" @click="verItem(props.row)">{{ props.row.marca }}</q-td>
                            <q-td key="modelo" :props="props" @click="verItem(props.row)">{{ props.row.modelo }}</q-td>
                            <q-td key="anio" :props="props" @click="verItem(props.row)">{{ props.row.anio }}</q-td>
                            <q-td key="color" :props="props" @click="verItem(props.row)">{{ props.row.color }}</q-td>
                            <q-td key="tipovehiculo" :props="props" @click="verItem(props.row)">{{
                                props.row.tipovehiculo }}</q-td>
                            <q-td key="version" :props="props" @click="verItem(props.row)">{{ props.row.version
                            }}</q-td>
                            <q-td key="fecha_aceptacion" :props="props" @click="verItem(props.row)">{{
                                props.row.fecha_aceptacion }}</q-td>
                            <q-td key="estatus" :props="props" @click="verItem(props.row)">
                                <q-badge v-if="props.row.estatus == 'Enviada'" color="blue"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'Rechazada'" color="red"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'CotizandoSolicitud'" color="purple"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'Aceptada'" color="green"
                                    label="CotizacionesDisponibles" />
                                <q-badge v-if="props.row.estatus == 'EnProcesoContrato'" color="green"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'ContratoVigente'" color="black"
                                    :label="props.row.estatus" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VistasPreviasPDF from "../../PDF/VistasPreviasPDF.vue";
import moment from 'moment';
export default {
    components: {
        VistasPreviasPDF
    },
    data() {
        return {
            loading: false,
            solicitudes: [],
            columns: [
                { name: 'fecha_solicitud', label: 'Fecha de Solicitud', field: 'fecha_solicitud', align: 'center', sortable: true },
                { name: 'marca', label: 'Marca', field: 'marca', align: 'center', sortable: true },
                { name: 'modelo', label: 'Modelo', field: 'modelo', align: 'center', sortable: true },
                { name: 'anio', label: 'Año', field: 'anio', align: 'center', sortable: true },
                { name: 'color', label: 'Color', field: 'color', align: 'center', sortable: true },
                { name: 'tipovehiculo', label: 'Tipo Vehiculo', field: 'tipovehiculo', align: 'center', sortable: true },
                { name: 'version', label: 'Versión', field: 'version', align: 'center', sortable: true },
                { name: 'fecha_aceptacion', label: 'Fecha de Aceptación', field: 'fecha_solicitud', align: 'center', sortable: true },
                { name: 'estatus', label: 'Estatus', field: 'estatus', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            selectSolicitud: null,
            listaCotizaciones: [],
            dialogDetalles: false,
            cotizacionSeleccionada: null,

            dialogAceptarCotizacion: false,
            dialogVistaPrevia: false
        }
    },
    mounted() {
    },
    computed: {
        userStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
        this.GetSolicitudesUsuario();
    },
    methods: {
        AceptarCotizacion() {
            if (this.cotizacionSeleccionada == null) {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Debera seleccionar una cotización de su conveniencia.', messageColor: 'white' })
            }

            this.dialogAceptarCotizacion = true
        },
        async verItem(item) {
            if (item.estatus == 'Eviada') {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Estamos procesando su solicitud para su aceptación.', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
            }
            if (item.estatus == 'CotizandoSolicitud') {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Estamos generando las cotizaciones de su solicitud.', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
            }
            if (item.estatus == 'EnProcesoContrato') {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Su solicitud está en proceso de contratación con la cotización que ha seleccionado.', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
            }

            if (item.estatus == "ContratoVigente") {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Su solicitud ya cuenta con un contrato vigente, podra visualizarlo en el apartado de Mis Contratos.', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
            }

            if (item.estatus == 'Aceptada') {
                this.selectSolicitud = item

                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
                await this.GetCotizaciones();
                this.dialogDetalles = true
                this.$q.loading.hide()
            }
            if (item.estatus == 'Rechazada') {
                this.$q.notify({
                    position: 'center',
                    progress: true,
                    message: item.notas,
                    color: 'error',
                    multiLine: true,
                    icon: 'mdi-cancel',
                    actions: [
                        { label: 'Cerrar', color: 'yellow', handler: () => { /* ... */ } }
                    ]
                })

                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
            }

        },
        async GetSolicitudesUsuario() {
            this.loading = true
            try {
                let respuesa = await axios.get('Catalogos/GetSolicitudesUsuario/' + this.userStore._id)
                console.log(respuesa)
                this.solicitudes = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async GetCotizaciones() {
            try {
                let respuesa = await axios.get('Catalogos/GetCotizaciones/' + this.selectSolicitud._id_usuario + '/' + this.selectSolicitud._id)
                console.log(respuesa.data)
                this.listaCotizaciones = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async UpdateAceptarCotizacion() {
            try {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Aceptando cotización. Espere...', messageColor: 'white' })
                let respuesa = await axios.put('Catalogos/UpdateCotizacionFinalizacion/' + this.cotizacionSeleccionada._id + '/' + this.selectSolicitud._id + '/Aceptada')
                console.log(respuesa)

                this.$q.notify({ type: 'positive', position: 'top-right', message: `La cotización se acepto correctamente.` });
                this.$q.loading.hide()
                this.GetSolicitudesUsuario()
                this.dialogAceptarCotizacion = false
                this.dialogDetalles = false
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al eliminar la cotización, intentelo nuevamente.` });
                console.log(error)
            }
        },
        descargarArchivo(documento) {
            const link = document.createElement('a');
            link.href = documento.cotizacion_agencia;
            link.download = documento.nombre_archivo_agencia || 'archivo.pdf';
            link.click();

            const link2 = document.createElement('a');
            link2.href = documento.cotizacion_arrendafit;
            link2.download = documento.nombre_archivo_arrendafit || 'archivo.pdf';
            link2.click();
        },

        descargarPDFPrevia() {
            const fileName = this.selectSolicitud.rfc + "_" + this.selectSolicitud.razon_social + "_" + this.selectSolicitud.marca + "_" + this.selectSolicitud.modelo + ".pdf";
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },
        VerArchivo(documento) {
            // const link2 = document.createElement('a');
            // link2.href = documento.cotizacion_arrendafit;
            // link2.download = documento.nombre_archivo_arrendafit || 'archivo.pdf';
            // link2.click();
            this.$store.state.auth.storeBase64Cotizacion = documento.cotizacion_arrendafit
            this.dialogVistaPrevia = true
        }
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.q-table thead,
[dir] .q-table tr,
[dir] .q-table th {
    border-color: #0094ca !important;
}

.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>